<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M33 46H9C6.8 46 5 44.2 5 42L5 14H9L9 42H33V46ZM39 38L17 38C14.8 38 13 36.2 13 34L13 6.00001C13 3.80001 14.8 2.00001 17 2.00001L39 2.00001C41.2 2.00001 43 3.80001 43 6.00001L43 34C43 36.2 41.2 38 39 38ZM39 6.00001L17 6.00001L17 34H39L39 6.00001Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
